import { Directive, ElementRef, Renderer2, HostListener, Input, OnInit, SecurityContext } from '@angular/core';
import { Title, DomSanitizer } from '@angular/platform-browser';

declare var $: any;

@Directive({
    selector: '[pageTitle]',
    providers: [Title]
})
export class UpsPageTitle implements OnInit {
    @Input('pageTitle') pageTitle: string;

    constructor(private el: ElementRef, private render: Renderer2, private title: Title, private sanitizer: DomSanitizer) {
    }

    ngOnInit() {
        this.title.setTitle(this.pageTitle.replace(/(<([^>]+)>)/ig, '') + ' | UPS - United States');
        this.pageTitle = this.sanitizer.sanitize(SecurityContext.HTML, this.pageTitle);
        $('h1').replaceWith('<h1><span>' + this.pageTitle + '</span></h1>')
    }

    ngAfterViewInit() {
        $('h1').focus();
    }


}
